import { render, staticRenderFns } from "./FixedTagPrint.vue?vue&type=template&id=204f82ce"
import script from "./FixedTagPrint.vue?vue&type=script&lang=js"
export * from "./FixedTagPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports